import React, {useContext} from 'react';
import styles from "../styles.module.scss";
import cn from "classnames";
import {Button} from "@shopify/polaris";
import {checkUsableCookie} from "../../../../helpers/cookie/checkUsableCookie";
import {COOKIE_ANALYTICS, COOKIE_FUNCTIONALITY} from "../../../../utils/constants";
import {COOKIE_CONTEXT} from "../../../providers/CookieProvider";
import useTranslation from "next-translate/useTranslation";
import {CUSTOMER_SUPPORT} from "../../../../utils/i18nNameSpaces";
import boy from "/public/contactus/boy.svg";
import Image from "next/image";

const Index = ({t, phone}) => {
  const {openBanner, openCookieToast, isBannerOpen} = useContext(COOKIE_CONTEXT);

  const liveChat = () => {
    if (!checkUsableCookie([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS])) {
      if (isBannerOpen) {
        openCookieToast();
      }
      openBanner([COOKIE_FUNCTIONALITY, COOKIE_ANALYTICS]);
      return;
    }
     window.__supportStartChat && window.__supportStartChat()
    return false;
  }

  return (
    <div className={cn(styles["chat"], styles["block"])}>
      <div className={styles["container"]}>
        <div className={styles["content"]}>
          <h4 className={styles["block-header"]}>{t("chat.header")}</h4>
          <p>{t("chat.text")}</p>
          {
            phone ?
              <Button primary url={`tel:${phone}`} size={"large"}>{t("chat.btn")}</Button>
              :
              <Button primary onClick={liveChat} size={"large"}>{t("chat.btn")}</Button>
          }
        </div>
        <div className={styles["img-wrapper"]}>
          <Image src={boy} quality={100} layout={"responsive"}/>
        </div>
      </div>
    </div>
  );
};

export default Index;